import React from "react";
import Table from "react-bootstrap/Table";
import { ResultWithRider, SnapshotWithEventandRider, TeamWithRider } from "../../../../types/model";
import getCountryISO2 from "country-iso-3-to-2";
import ReactCountryFlag from "react-country-flag";
import { calculateMultiplier } from "../../../../utils/utils";


interface PointsBreakdownMultiplierModeProps {
	results: ResultWithRider[];
	snapshot: SnapshotWithEventandRider;
	team: TeamWithRider;
}

const PointsBreakdownMultiplierMode: React.FC<PointsBreakdownMultiplierModeProps> = ({
	results,
	snapshot,
	team,
}) => {
	return (
		<Table
			striped
			bordered
			hover
			className="rounded"
			style={{ fontSize: "0.7rem", borderRadius: "10px" }}
		>
			<thead>
				<tr>
					<th>Rider</th>
					<th>Event Points</th>
					<th>Multiplier</th>
					<th>Total Points</th>
				</tr>
			</thead>
			<tbody>
				{results?.length > 0 &&
					results
						.filter(
							(result: ResultWithRider) =>
								result.event === snapshot.event._id &&
								snapshot.riders.some(
									(rider) => rider.rider._id === result.rider._id
								)
						)
						.map((filteredResult: ResultWithRider) => (
							<tr key={filteredResult._id}>
								<td>
									{getCountryISO2(
										(filteredResult?.rider?.country ?? "").toUpperCase().trim()
									) ? (
										<ReactCountryFlag
											countryCode={getCountryISO2(
												(filteredResult?.rider?.country ?? "")
													.toUpperCase()
													.trim()
											)}
											svg
											style={{ width: "3.5rem" }}
										/>
									) : (
										filteredResult.rider.country
									)}
									<b>{filteredResult.rider.last_name}</b>{" "}
									{filteredResult.rider.first_name}
								</td>
								<td>{filteredResult.total_points}</td>
								<td>
									{calculateMultiplier(
										filteredResult.rider.ratings?.find(
											(rating: any) => rating.sport === team?.sport
										)?.rating ?? 0
									)}
								</td>
								<td>
									{(
										(filteredResult.total_points ?? 0) *
										calculateMultiplier(
											filteredResult.rider.ratings?.find(
												(rating: any) => rating.sport === team?.sport
											)?.rating ?? 0
										)
									).toFixed(2)}
								</td>
							</tr>
						))}
			</tbody>
		</Table>
	);
};

export default PointsBreakdownMultiplierMode;